import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GlobalButton from "../../components/button";
import PackageCard from "../../components/cards/PackageCard";
import ProductCardSkeleton from "../../components/skeletons/ProductCardSkeleton";
import { useSnackbar } from "../../lib/context/snackbarContext";
import {
  incrementPage,
  setHasMore,
  setPackages,
} from "../../lib/redux/slices/ecomPackageSlice";
import { getCustomPackages } from "../../services/userPackageApiFn";

const Packages = () => {
  const dispatch = useDispatch();
  const { showSnackbar } = useSnackbar();

  const { packages, currentPage, limit, hasMore } = useSelector(
    (state) => state.ecompackageReducer
  );

  const [isLoading, setIsLoading] = useState(packages.length === 0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  useEffect(() => {
    if (packages.length === 0) {
      fetchPackages(currentPage, limit);
    }
  }, []);

  const fetchPackages = async (pageToLoad, limit) => {
    try {
      const response = await getCustomPackages(pageToLoad, limit);
      if (response.data.status === "success") {
        const data = response.data.data.packages;
        dispatch(setPackages(data));
        dispatch(setHasMore(data.length >= limit));
      }
    } catch (error) {
      showSnackbar(error?.message);
    } finally {
      setIsLoading(false);
      setIsLoadingMore(false);
    }
  };

  const handleShowMore = () => {
    const nextPage = currentPage + 1;
    dispatch(incrementPage());
    setIsLoadingMore(true);
    fetchPackages(nextPage, limit);
  };

  return (
    <Box component={"section"} mt={18}>
      <Container maxWidth={"lg"} sx={{ mt: 0 }}>
        {isLoading === false && packages?.length === 0 && (
          <Typography variant="h4" fontWeight={600} textAlign={"center"}>
            No Packages Found !!
          </Typography>
        )}

        <Grid container spacing={2} mt={1}>
          {isLoading
            ? Array.from({ length: 8 }).map((_, index) => (
                <Grid key={index} item xs={6} sm={4} md={2.4}>
                  <ProductCardSkeleton />
                </Grid>
              ))
            : packages?.map((item, index) => (
                <Grid key={index} item xs={6} sm={4} md={2.4}>
                  <PackageCard cardData={item} colorName={"text.black"} />
                </Grid>
              ))}
        </Grid>

        <Stack my={4} alignItems={"center"}>
          {hasMore && (
            <GlobalButton
              btnText={"Show More"}
              handleClickBtn={handleShowMore}
              startIcon={isLoadingMore && <CircularProgress size={26} />}
              styleProps={{
                height: 50,
                width: 200,
                backgroundColor: "text.white",
                color: "text.black",
                borderRadius: 1.5,
                fontSize: "1rem",
                fontWeight: 600,
              }}
            />
          )}
        </Stack>
      </Container>
    </Box>
  );
};

export default Packages;
